<template>
  <div class="ifram-root">
    <div>
      <div class="menu-btn" @click="change_menu_index(index)" v-for="(menu,index) in menu_config" :key="menu.path">
        <div class="menu-bg" :class="{active:menu_index==index}"></div>
        <div class="menu-btn-title">{{ menu.title }}</div>
      </div>
    </div>

    <div class="sub-menu-line"></div>

    <div style="margin-bottom: 10px;">
      <template v-if="menu_config[menu_index].title!=='历史数据'">
        <div class="sub-menu-btn" @click="change_sub_menu_index(index)"
             v-for="(sub_menu,index) in menu_config[menu_index].children" :key="sub_menu.path">
          <div class="sub-menu-bg" :class="{active:sub_menu_index==index,rotate:index>0}"></div>
          <div class="sub-menu-btn-title">{{ sub_menu.title }}</div>
        </div>
      </template>
    </div>

    <div style="margin: 0 auto;margin-bottom: 10px;width: 100%" v-if="isMobileName">
      <div class="jifen-button-box" @click="change_sub_sub_menu_index(index)"
           v-for="(sub_sub_menu,index) in menu_config[menu_index].children[sub_menu_index].children"
           :key="sub_sub_menu.path">
        <div class="jifen-button" :class="{active:sub_sub_menu_index==index,rotate:index>0}">{{ sub_sub_menu.title }}
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import lodash from 'lodash'

export default {
  name: "index",
  data: function () {
    return {
      menu_index: 0,
      sub_menu_index: 0,
      sub_sub_menu_index: 0,
      isMobileName: null,
      menu_config: [
        {
          title: "赛事赛程",
          path: "/iframe_zoom/matchSchedule",
          children: [
            {
              title: "常规赛",
              // path: "/iframe/matchSchedule/regularSeason",
              path: "/iframe_zoom/matchSchedule/regularSeason?id=1",
              // path: "/iframe/matchSchedule/playOffs",
              children: [
                {
                  title: "战队积分榜",
                  path: "/iframe_zoom/matchSchedule/regularSeason?id=1",
                  // path: "/iframe/matchSchedule/playOffs?id=1",
                },
                {
                  title: "赛程",
                  path: "/iframe_zoom/matchSchedule/regularSeason?id=2",
                  // path: "/iframe/matchSchedule/playOffs?id=2",
                }
              ]
            },
            {
              title: "季后赛",
              path: "/iframe_zoom/matchSchedule/playOffs",
              // path: "/iframe/matchSchedule/regularSeason?id=1",
            },
            // {
            //   title: "赛程",
            //   path: "/iframe/matchSchedule/regularSeason",
            //   // path: "/iframe/matchSchedule/playOffs",
            //   children: [
            //     {
            //       title: "战队积分榜",
            //       path: "/iframe/matchSchedule/regularSeason?id=1",
            //       // path: "/iframe/matchSchedule/playOffs?id=1",
            //     },
            //     {
            //       title: "赛程",
            //       path: "/iframe/matchSchedule/regularSeason?id=2",
            //       // path: "/iframe/matchSchedule/playOffs?id=2",
            //     }
            //   ]
            // },
          ],
        },
        {
          title: "赛事数据",
          path: "/iframe_zoom/matchData",
          children: [
            {
              title: "赛事数据",
              path: "/iframe_zoom/matchData/teamData",
            },
            {
              title: "地图数据",
              path: "/iframe_zoom/matchData/mapData",
            },
          ],
        },
        {
          title: "历史数据",
          path: "/iframe_zoom/histroyData",
          children: [
            {
              title: "详情",
              path: "/iframe_zoom/histroyData/detail",
            },
          ],
        },
        // {
        //   title:"数据分析",
        //   path:"/iframe/dataAnalysis",
        //   children:[
        //     {
        //       title:"战队",
        //       path:"/iframe/dataAnalysis/teamData",
        //     },
        //     {
        //       title:"选手",
        //       path:"/iframe/dataAnalysis/playerData",
        //     },
        //   ],
        // },
      ],
    }
  },
  created: function () {
    const ISMOBILE = function () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    };
    this.isMobileName = ISMOBILE()
    if (this.$route.path == '/iframe_zoom') {
      this.router_to_page()
    } else {
      lodash.each(this.menu_config, (menu, index) => {
        if (this.$route.path.indexOf(menu.path) >= 0) {
          this.menu_index = index

          lodash.each(menu.children, (sub_menu, index_2) => {
            if (this.$route.path.indexOf(sub_menu.path) >= 0) {
              this.sub_menu_index = index_2

              if (sub_menu.children != undefined && sub_menu.children.length > 0) {
                lodash.each(sub_menu.children, (sub_sub_menu, index_3) => {
                  let path = this.$route.path;
                  if (this.$route.query) {
                    path += '?id=' + this.$route.query.id
                  }
                  if (path.indexOf(sub_sub_menu.path) >= 0) {
                    this.sub_sub_menu_index = index_3

                    return false
                  }
                })
              }
              return false
            }
          })
          return false
        }
      })
    }
  },
  methods: {
    change_menu_index(new_index) {
      if (new_index != this.menu_index) {
        this.menu_index = new_index
        this.sub_menu_index = 0
        this.router_to_page()
      }
    },
    change_sub_menu_index(new_sub_index) {
      if (new_sub_index != this.sub_menu_index) {
        this.sub_menu_index = new_sub_index
        this.router_to_page()
      }
    },
    change_sub_sub_menu_index(new_sub_sub_index) {
      if (new_sub_sub_index != this.sub_sub_menu_index) {
        this.sub_sub_menu_index = new_sub_sub_index
        this.router_to_page()
      }
    },
    router_to_page() {
      if (this.menu_config[this.menu_index].children[this.sub_menu_index].children !== undefined && this.menu_config[this.menu_index].children[this.sub_menu_index].children.length > 0) {
        this.$router.push({path: this.menu_config[this.menu_index].children[this.sub_menu_index].children[this.sub_sub_menu_index].path})
      } else {
        this.$router.push({path: this.menu_config[this.menu_index].children[this.sub_menu_index].path})
      }
    },
  }
}
</script>

<style scoped>
/deep/ .schedule-list {
  background: rgba(0, 0, 0, .5);
}

.ifram-root {
  width: 1200px;
  height: 800px;
  /*min-width: 100vw;*/
  /*min-height: 56vw;*/
  zoom: 1.3375;
  /*background-image: url("~@/assets/images/CFHL2022KV.png");*/
  /*background-size: cover;*/
  padding-top: 17px;
  margin: 0 auto;
}

.menu-btn {
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 150px;
  height: 50px;
  margin: 0px 5px;
  cursor: pointer;
}

.sub-menu-line {
  width: 1100px;
  margin: 7px auto;
  border-top: 1px solid #fabf8b;
}

.menu-bg, .menu-btn-title {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
}

.menu-bg {
  z-index: 1;
  background-image: url(/static/img/iframe/menu-unactive.png);
}

.menu-btn-title {
  font-size: 22px;
  line-height: 50px;
  color: #ffffff;
  z-index: 2;
}

.menu-bg.active {
  background-image: url(/static/img/iframe/menu-active.png);
}


.sub-menu-btn {
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 200px;
  height: 40px;
  margin: 0px 1px;
  cursor: pointer;
}

.sub-menu-bg, .sub-menu-btn-title {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
}

.sub-menu-bg {
  z-index: 1;
  background-image: url(/static/img/iframe/sub-menu-unactive.png);
}

.sub-menu-btn-title {
  font-size: 20px;
  line-height: 40px;
  color: #ffffff;
  z-index: 2;
}

.sub-menu-bg.active {
  background-image: url(/static/img/iframe/sub-menu-active.png);
}

.sub-menu-bg.rotate {
  transform: rotate(180deg);
}

/*.mobileStyle{display: none}*/
.jifen-button-box {
  display: inline-block;
  width: 47%;
  border-bottom: 1px solid #956840;
}

.jifen-button {
  width: 100%;
  height: 30px;
  color: #FFFFFF;
  display: inline-block;
  line-height: 30px;
  margin-right: 10px;
  font-size: 18px;
  padding-bottom: 2px;
}

.jifen-button.active {
  position: relative;
  border-bottom: 1px solid #fabf8b;
  color: #fabf8b;
}

.jifen-button.active:before {
  content: "";
  position: absolute;
  top: 27px;
  left: 44%;
  width: 10px;
  height: 10px;
  background-image: url("../../assets/images/map.svg");
  background-size: 100%;
  transition: all 0.5s;
  transform: rotate(45deg);
}


@media only screen and (max-width: 751px) {

  /*.mobileStyle{display: block}*/
  .ifram-root {
    width: 100vw;
    height: auto;
    min-height: 110vh;
    /*padding-top: .24rem;*/
    /*padding-bottom: .24rem;*/
    background-image: url("~@/assets/images/2024CFPLM.png");
    /*background-image: url("~@/assets/images/new_bg.jpg");*/
    /*background-image: url("~@/assets/images/new_bg1_mobile.jpeg");*/
    /*background-image: url("~@/assets/images/newBg.png");*/
    /*background-position: -50vw 0;*/
    background-repeat: no-repeat;
    background-size: 100vw 110vh;
    box-sizing: border-box;
    background-attachment: fixed;
  }

  .sub-menu-btn {
    width: 100px;
    height: 24px;
  }

  .sub-menu-line {
    width: 100%;
  }

  .sub-menu-bg {
    background-size: 100% 100%;
  }

  .sub-menu-bg.active {
    background-size: 100% 100%;
  }

  .sub-menu-btn-title {
    font-size: 14px;
    line-height: 24px;
  }

  .menu-btn {
    width: 95px;
    height: 35px;
  }

  .menu-bg.active {
    background-size: 100% 100%;
  }

  .menu-bg {
    background-size: 100% 100%;
  }

  .menu-btn-title {
    font-size: 18px;
    line-height: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iframe/Index_zoom.vue